import { useTranslation } from 'react-i18next';

import AttendanceGif from '../../../../../../assets/attendance.gif';
import { i18nNS } from '../../../../i18n';
import TileIntroductionForm, { TileIntroductionFormProps } from '../../../shared/TileIntroductionForm';
import TileIntroductionLayout from '../../../shared/TileIntroductionLayout';
import useIntroduction, { UseIntroduction } from './vm';

export interface IntroductionProps
  extends Pick<TileIntroductionFormProps, 'className' | 'onNext'>,
    UseIntroduction {}

const Introduction = ({ className, onNext, ...vmProps }: IntroductionProps) => {
  const { t } = useTranslation([i18nNS.CLASS]);

  useIntroduction(vmProps);

  return (
    <TileIntroductionForm className={className} onNext={onNext}>
      <TileIntroductionLayout
        imageSrc={AttendanceGif}
        description={t(
          'click_a_button_to_record_attendance_of_everyone_sitting_in_the_lecture_hall_using_acadly_s_proprietary_mesh_network_based_technology',
          { ns: i18nNS.CLASS }
        )}
        color="warning"
        studentRespondsOn={{
          iOS: true,
          android: true,
          web: false,
        }}
      />
    </TileIntroductionForm>
  );
};

export default Introduction;
